import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-746818a4")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DefaultIcon = _resolveComponent("DefaultIcon")
  const _component_router_link = _resolveComponent("router-link")

  return _withDirectives((_openBlock(), _createBlock(_component_router_link, {
    class: [_ctx.activeRoute === true ? 'text-gray-50 dark:text-gray-700 underline' : 'text-gray-50  dark:text-gray-700', 'flex', 'transform hover:text-white py-2 rounded-3xl text-sm font-medium ' + _ctx.itemWidth + ' ' + _ctx.cssClass],
    to: _ctx.redirectLink
  }, {
    default: _withId(() => [
      (_ctx.itemIconPre.length > 0)
        ? (_openBlock(), _createBlock(_component_DefaultIcon, {
            key: 0,
            icon: _ctx.itemIconPre,
            class: "pr-1"
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.itemText) + " ", 1),
      (_ctx.itemIconAfter.length > 0)
        ? (_openBlock(), _createBlock(_component_DefaultIcon, {
            key: 1,
            icon: _ctx.itemIconAfter,
            class: "pl-1"
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class", "to"])), [
    [_vShow, _ctx.showItem]
  ])
})